module.exports = __webpack_public_path__ + "img/after5.13ce6256.jpg";